export default __webpack_public_path__ + "static/media/learose-2048w.07f83674.avif";